'use client';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import { toast } from 'react-toastify';
import NextImage from '@/features/Image';

// Dynamically import components
const Countdown = dynamic(() => import('@/features/countdown/CountDown'));

export default function GroupCard({ group }: any) {
  const copyLink = (url: string) => {
    if (typeof window === 'undefined') return;
    const fullUrl = `${window.location.origin}/${url}`;
    navigator.clipboard
      .writeText(fullUrl)
      .then(() => {
        toast.success('Link copied to clipboard');
      })
      .catch((err) => {
        toast.error('Failed to copy link: ', err);
      });
  };

  return (
    <>
      <div className="group-default inner-quickview inner-icon">
        <figure className="group-thumb">
          <Link href={`/product/${group.product.slug}`}>
            <NextImage
              src={group.product.thumbnail_image || '/images/placeholder.jpg'}
              alt="Product image"
              width={800}
              height={800}
              className="fade-in"
            />
          </Link>
          <div className="group-id">
            Duration: <Countdown expiredAt={group.expired_at} />
          </div>
          <div className="btn-icon-group">
            <a
              href="#"
              className="btn-icon btn-add-cart product-type-simple"
              onClick={(e) => {
                e.preventDefault();
                copyLink(`/group-shopping/${group.token}`);
              }}
            >
              <i className="fas fa-clone"></i>
            </a>
          </div>
        </figure>
        <div className="product-details">
          <div className="price-box">
            <span className="product-price">৳{group.group_purchase_price}</span>

            {group?.group_purchase_price !== group?.product?.price && (
              <span className="product-price">
                <del>৳{group.product?.price}</del>
              </span>
            )}
          </div>
          <div className="title-wrap">
            <h6 className="product-title short-text mb-1 fw-medium">
              <Link href={`/product/${group.product.slug}`}>
                {group.product.name}
              </Link>
            </h6>
          </div>
          <div className="short-desc">
            <p className="product-desc">{group.description}</p>
          </div>
          <div className="group-creator">
            <div className="group-creator-thumb">
              <NextImage
                src={
                  group.group_admin?.avatar || '/images/dummy-pic-female.jpg'
                }
                alt="Creator"
                width={50}
                height={50}
              />
            </div>
            <div className="group-creator-name">
              <h5>
                <span>Created By</span>
                {group.group_admin?.name}
              </h5>
            </div>
          </div>
          <div className="group-member">
            <div className="group-member-content">
              <span>Joined members</span>
              <span>
                {group.current_user_quantity}/{group.total_user_quantity}
              </span>
            </div>
            <div className="group-member-bar">
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{
                    width: `${(group.current_user_quantity / group.total_user_quantity) * 100}%`,
                  }}
                  aria-valuenow={group.current_user_quantity}
                  aria-valuemin={0}
                  aria-valuemax={group.total_user_quantity}
                ></div>
              </div>
            </div>
          </div>
          {group.is_purchased ? (
            <Link
              href="#"
              className="btn btn-dark btn-quickview d-block remove-position"
            >
              Joined
            </Link>
          ) : (
            <Link
              href={`/group-shopping/${group.token}`}
              className="btn btn-dark btn-quickview d-block remove-position"
            >
              Join Group
            </Link>
          )}
          <a
            href="#"
            className="btn btn-dark btn-quickview d-block mt-1 remove-position"
            onClick={(e) => {
              e.preventDefault();
              copyLink(`/group-shopping/${group.token}`);
            }}
          >
            Share
          </a>
        </div>
      </div>
    </>
  );
}
